// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body {
  height: 900px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/grid-settings-summary/grid-settings-summary.component.less"],"names":[],"mappings":"AAGA;EACI,wBAAA;AAFJ","sourcesContent":["@import (reference) url('../../../../assets/ngb-modals.less');\n@import (reference) url('../../../../assets/tables.less');\n\n.modal-body {\n    height: 900px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
